import { EventLogDto } from '@services/dtos'
import { baseCrudReducer } from './baseCrudReducer'
import { entityEventLogService, EntityEventLogsFilters } from '@services/entityEventLogsService'

const { reducer, actions, thunks } = baseCrudReducer<
  EventLogDto,
  {},
  {},
  EntityEventLogsFilters
>('entityEventLog', entityEventLogService)

export default reducer

export const { setFilters: setEntityEventLogFilters } = actions

export const { getAll: getEntityEventLogs } = thunks
